import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { HTTP_RESPONSE_CODE } from '../../constants/http';
import {
    RETRIABLE_ERRORS, PAGE_REFRESH_MESSAGE, NETWORK_ERRORS, getUserErrorMessage, DEFAULT_HELP_POPUP_TITLE,
    LANTERN_ERROR_CODES,
} from '../../constants/error';
import HelpPopup from '../components/helpPopup/HelpPopup';
import OkButton from './OkButton';
import LogoutButton from './LogoutButton';
import RetryButton from './RetryButton';
import RefreshButton from './RefreshButton';
import { COMMON_HELP_POPUP_BUTTON_CLASSNAME } from "../../constants/components";

export default class AppErrorView extends Component {
    constructor(props) {
        super(props);
        this.getApiErrorHandlingButtons = this.getApiErrorHandlingButtons.bind(this);
    }

    getApiErrorHandlingButtons() {
        // These are errors coming from retriable GET requests
        if (RETRIABLE_ERRORS.includes(this.props.appLevelErrorStatus)) {
            const buttons = [
                <RetryButton
                    key="retryButton-1"
                    onClick={this.props.onRetry}
                    isPrimary />];
            if (NETWORK_ERRORS.includes(this.props.appLevelErrorStatus)
                || HTTP_RESPONSE_CODE.SERVER_ERROR === this.props.appLevelErrorStatus) {
                buttons.push(
                    <LogoutButton
                        key="appLevelError-logoutButton"
                        onClick={this.props.logUserOut}
                        className={COMMON_HELP_POPUP_BUTTON_CLASSNAME}
                        isSecondary />,
                );
            }
            return buttons;
        }

        if (this.props.appLevelErrorStatus === HTTP_RESPONSE_CODE.UNAUTHORIZED) {
            return [<OkButton
                key="appLevelErrorButton-1"
                onClick={this.props.onAuthenticationFailed}
                isPrimary />];
        }

        if (this.props.appLevelErrorStatus === LANTERN_ERROR_CODES.OFFLINE_RESULT) {
            return [
                <RetryButton
                    key="retryButton-1"
                    onClick={this.props.syncOfflineResultsAndContinue}
                    isPrimary />
            ];
        }

        return [<LogoutButton
            key="appLevelError-logoutButton"
            onClick={this.props.logUserOut}
            className={COMMON_HELP_POPUP_BUTTON_CLASSNAME}
            isSecondary
        />];
    }

    render() {
        if (this.props.isLanternUser) {
            if (this.props.appLevelErrorStatus !== undefined) {
                return (
                    <HelpPopup
                        title={DEFAULT_HELP_POPUP_TITLE}
                        problem={getUserErrorMessage(this.props.appLevelErrorStatus)}
                        buttons={this.getApiErrorHandlingButtons()} />
                );
            } if (this.props.isFileLoadingFailed) {
                return (
                    <HelpPopup
                        title={DEFAULT_HELP_POPUP_TITLE}
                        problem={PAGE_REFRESH_MESSAGE}
                        buttons={[<RefreshButton
                            key="appLevelError-refreshButton"
                            onClick={this.props.onPageReload}
                            isPrimary />]} />
                );
            } if (this.props.secureBrowserError) {
                return (
                    <HelpPopup
                        title={DEFAULT_HELP_POPUP_TITLE}
                        problem={getUserErrorMessage(this.props.secureBrowserError)}
                        buttons={[<OkButton
                            key="goToStudentHome-1"
                            onClick={this.props.goToHomeScreen}
                            isPrimary />]} />
                );
            }
        }

        return null;
    }
}

AppErrorView.propTypes = {
    appLevelErrorStatus: PropTypes.number,
    onRetry: PropTypes.func.isRequired,
    isFileLoadingFailed: PropTypes.bool,
    onPageReload: PropTypes.func.isRequired,
    onAuthenticationFailed: PropTypes.func.isRequired,
    logUserOut: PropTypes.func.isRequired,
    isLanternUser: PropTypes.bool,
    /* eslint-disable no-unused-vars, react/no-unused-prop-types */
    pageReloadCallback: PropTypes.func,
    /* eslint-enable no-unused-vars, react/no-unused-prop-types */
    syncOfflineResultsAndContinue: PropTypes.func.isRequired,
    secureBrowserError: PropTypes.number,
    goToHomeScreen: PropTypes.func,
};

AppErrorView.defaultProps = {
    appLevelErrorStatus: undefined,
    isFileLoadingFailed: false,
    isLanternUser: false,
    pageReloadCallback: () => {},
    secureBrowserError: 0,
    goToHomeScreen: () => {},
};
